import { create } from "zustand";
import { getAgentCallingData, getAgentFeedback, getUserProfile } from "../api";
import { persist } from "zustand/middleware";
import { isEmpty } from "lodash";
import { useRoutePermissions } from "modules/user_management/store/permissionsStore";
import secureLocalStorage from "react-secure-storage";

export const useUserProfile = create(
  persist(
    (set, get) => ({
      profileData: "",
      isLoading: false,
      isError: false,
      errorMessage: "",
      fetchProfileDetails: async (forceRefresh = false) => {
        const state = get();
        // Only fetch if empty or forced refresh
        if(isEmpty(state.profileData) || forceRefresh){
          try {
            set({ isLoading: true });
            const response = await getUserProfile();
            set({ profileData: response?.data, isLoading: false });

            // Also fetch route permissions for the user
            const userId = secureLocalStorage.getItem("id");
            if (userId) {
              const permissionsStore = useRoutePermissions.getState();
              await permissionsStore.fetchRoutePermissions(userId);
            }
          } catch (error) {
            set({
              isError: true, isLoading: false,
              errorMessage: error?.response?.data?.message || "Failed to fetch profile data.",

            });
          }
        }
      },

      // Force refresh profile and permissions
      refreshProfileAndPermissions: async () => {
        const userId = secureLocalStorage.getItem("id");
        try {
          set({ isLoading: true });
          const response = await getUserProfile();
          set({ profileData: response?.data, isLoading: false });

          if (userId) {
            const permissionsStore = useRoutePermissions.getState();
            await permissionsStore.fetchRoutePermissions(userId);
          }
        } catch (error) {
          set({
            isError: true, isLoading: false,
            errorMessage: error?.response?.data?.message || "Failed to refresh profile data."
          });
        }
      },
    }),
    {
      name: "user-profile-store",
      partialize: (state) => ({ profileData: state.profileData }), // Persist only `profileData`
    }
  )
);

export const useAgentCall = create((set) => ({
  agentCallData: {},
  agentFeedbackData:{},
  isLoading: false,
  isError: false,
  errorMEssage: "",
  fetchAgentCall: async () => {
    set({ isLoading: true });
    try {
      const response = await getAgentCallingData();
      set({ agentCallData: response?.data });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
      });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchAgentFeedback: async () => {
    set({ isLoading: true });
    try {
      const response = await getAgentFeedback();
      set({ agentFeedbackData: response?.data });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
      });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useCallingStore = create((set) => ({
  voitekkCalling: false,
  exotelCalling: false,
  knowlarityCalling: false,
  exotelAmeyoCalling: false,
  agamiCalling: false,
  ubonaCalling: false,
  updateCallingStatus: (callType, data) => {
    console.log({ [callType]: data });
    set({ [callType]: data });
  },
  disposeAllCalls: () => {
    set({
      voitekkCalling: false,
      exotelCalling: false,
      knowlarityCalling: false,
      exotelAmeyoCalling: false,
      agamiCalling: false,
      ubonaCalling: false,
    });
  },
}));
